export default __webpack_public_path__ + "static/media/aqi_3.904d5115.svg";